module.exports = __webpack_public_path__ + "img/logo.6a38a17b.svg";